import Vue from "vue";
import VueRouter from "vue-router";
import error404 from "@/404";
import axios from "@/plugins/axios.js";

Vue.use(VueRouter);
Vue.use(axios);

const requireAdmin = (to, from, next) => {
  // console.log('localStorage.getItem()', localStorage.getItem('userId'))
  if (!localStorage.getItem('userId')) {
    next('/user/login')
  } else {
    next ()
  }
}

const requireReg = (to, from, next) => {
  // console.log('localStorage.getItem()', localStorage.getItem('userId'))
  if (!sessionStorage.getItem('onlySearch')) {
    next()
  } else {
    alert('신청 기간이 아닙니다.')
  }
}

const checkIe = (_,__,next) =>{
  let agent = navigator.userAgent.toLowerCase();
  console.log("agent : ", agent);
  if ( (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1) || (agent.indexOf("msie") != -1)) {
    alert("지원하지 않는 브라우저입니다. Edge 또는 Chrome 에서 접속을 부탁드립니다.")
    return false;
  }

  next();
}

const routes = [
  {
    // 404 페이지
    path: "*",
    component: error404,
  },
  { path: "/", redirect: { name: "login" } },
  { // 관리자단 => 학습자단 컴퍼니 코드로 redirect용
    path: "/lnk/:companyCode",
    name: "lnk",
    component: () => import("@/pages/lnk.vue"),
  },

  { // url 학습자단 컴퍼니 코드로 redirect용
    path: "/link/:companyCode",
    name: "link",
    component: () => import("@/pages/link.vue"),
  },
  {
    path: "/user/login",
    name: "login",
    component: () => import("@/pages/login.vue"),
  },

  {
    path: "/user/fixPW/:time/:email/:code/:companycode",
    name: "fixPW",
    component: () => import("@/pages/fixPW.vue"),
  },
  {
    path: "/user/customPayment",
    name: "customPayment",
    component: () => import("@/pages/customPayment.vue"),
  },
  {
    path: "/user",
    name: "user",
    component: () => import("@/pages/user.vue"),
    beforeEnter: requireAdmin,

    children: [
      {
        path: 'reg',
        name: 'reg',
        component: () => import("@/pages/reg.vue"),
        beforeEnter: requireReg,
        children: [
          {
            path: 'init',
            name: 'reg-init',
            component: () => import("@/pages/reg/init.vue"),
          },
          {
            path: 'terms',
            name: 'reg-terms',
            component: () => import("@/pages/reg/terms.vue"),
          },
          {
            path: 'info',
            name: 'reg-info',
            component: () => import("@/pages/reg/info.vue"),
          },
          {
            path: 'select',
            name: 'reg-select',
            component: () => import("@/pages/reg/select.vue"),
          },
          {
            path: 'input',
            name: 'reg-input',
            component: () => import("@/pages/reg/input.vue"),
          },
          {
            path: 'payment',
            name: 'reg-payment',
            component: () => import("@/pages/reg/payment.vue"),
          },
          {
            path: 'complete',
            name: 'reg-complete',
            component: () => import("@/pages/reg/complete.vue"),
          }
        ]
      },
      {
        path: 'applyList',
        name: 'applyList',
        component: () => import("@/pages/applyList.vue"),
      },
    ]
  },

  {
    path: '/paymentRedirect',
    name: 'payment-redirect',
    component: () => import("@/pages/paymentRedirect.vue"),
  },
  // 윈도우 팝업용
  {
    path: '/user/reg/apply/detail',
    name: 'reg-apply-detail',
    component: () => import("@/components/reg/detailPopup.vue"),
  },
  {
    // 윈도우 팝업용
    path: "/user/reg/select/popup",
    name: "reg-select-popup",
    component: () => import("@/components/reg/popup.vue"),
  },
];

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  mode: "history",
  routes,
});

router.beforeEach(checkIe);

router.afterEach(() => {
  /**
   * 2022.02.03
   *   : window.applicationCache는 Deprecated 되었으므로 주석 처리
   */
  window.addEventListener('load', function () {
  }, false)
})

export default router;
